import Link from 'next/link';
import { mentionUrl, postUrl } from '../../../helpers/regex';
import { safeHref } from '../../../helpers/safeHref';
import { figtree } from '../../Landing/fonts';

const BTN_CLASS = `${figtree.className} tf-btn tw-inline-flex tw-cursor-pointer tw-items-center tw-gap-2 tw-rounded-full tw-border-0 tw-bg-primary-600 tw-px-6 tw-py-3 tw-text-[15px] tw-font-semibold tw-text-white tw-no-underline tw-shadow-[0_10px_30px_-10px_rgba(0,137,123,0.7)] tw-transition-all tw-duration-200 hover:-tw-translate-y-0.5 hover:tw-bg-primary-700 hover:tw-text-white`;

// Buttons authored in posts ("Book this tour", "Read part two") — styled
// like the site's own CTAs so user content keeps the editorial voice.
export default function PostBtn({
  link,
  text,
  isWhitelist,
  parseLinksToBlank,
  isUgcLinks,
  setExternalLinkModal,
}) {
  if (!link || !text) return <>no details</>;
  // Not a web link (javascript:, data:): show the text, link nothing.
  if (!safeHref(link)) return <p className="tw-py-4 tw-text-center">{text}</p>;
  let internalHref = '';
  const blogLink = link.match(postUrl);
  if (blogLink) internalHref = `/@${blogLink[1]}/${blogLink[2]}`;
  const mention = link.match(mentionUrl);
  if (mention) internalHref = `/@${mention[1]}`;
  if (!internalHref) internalHref = `/exit?url=${encodeURIComponent(link)}`;
  if (isWhitelist || isUgcLinks || !!setExternalLinkModal) internalHref = link;
  // Whitelisted URLs as normal external links
  if (isWhitelist || parseLinksToBlank || isUgcLinks)
    return (
      <div className="tw-py-4 tw-text-center">
        <a
          href={internalHref}
          target="_blank"
          rel="ugc noopener noreferrer"
          className={BTN_CLASS}
        >
          {text}
        </a>
      </div>
    );
  if (setExternalLinkModal)
    return (
      <div className="tw-py-4 tw-text-center">
        <button
          type="button"
          className={BTN_CLASS}
          onClick={() => setExternalLinkModal(internalHref)}
        >
          {text}
        </button>
      </div>
    );
  return (
    <div className="tw-py-4 tw-text-center">
      <Link href={internalHref} className={BTN_CLASS}>
        {text}
      </Link>
    </div>
  );
}
